// Used for Primary announcements and Secondary announcements, and About The Library section
type CustomSection = {
  isEnabled: boolean;
  name: string;
  title?: string;
  sections?: {};
  content?: string;
}


class HomeController {

  $scope: any;
  configService: ConfigService;

  constructor(
    $scope: any,
    configService: ConfigService
  ) {
    this.$scope = $scope;
    this.$scope.customSections = {};
    this.configService = configService;
    this.$scope.config = this.configService.data.homePage;
    this.init();
  }

  init() {
    this.$scope.customSections = this.defineCustomSections()
  }

  defineCustomSections() {

    let customSections: CustomSection[] = []

    let sectionsOrder = this.configService.data.homePage.sectionsOrder

    for (let sectionName of sectionsOrder) {
      switch (sectionName) {
        case "primary_announcements":
          this.configService.data.homePage.primaryAnnouncementsEnabled ? customSections.push(this.getAnnouncements("primaryAnnouncements")) : null;
          break;
        case "linked_cards":
          this.configService.data.homePage.cardsEnabled ? customSections.push(this.getLinkedCards()) : null;
          break;
        case "about_the_library":
          this.configService.data.homePage.aboutLibraryEnabled ? customSections.push(this.getAboutTheLibrary()) : null;
          break;
        case "secondary_announcements":
          this.configService.data.homePage.secondaryAnnouncementsEnabled ? customSections.push(this.getAnnouncements("secondaryAnnouncements")) : null;
          break;
        default:
          console.warn(`Unknown section name: ${sectionName}`);
      }
    }
    this.configService.data.homePage.footerEnabled ? customSections.push(this.getFooter()) : null;



    return customSections;
  }


  getAnnouncements(sectionName: string): CustomSection {

    let customSection: CustomSection = {
      name: sectionName,
      isEnabled: false, // default value, will be updated based on config
      title: this.configService.data.homePage.primaryAnnouncementsTitle
    }

    switch (sectionName) {
      case "primaryAnnouncements":
        customSection.isEnabled = this.configService.data.homePage.primaryAnnouncementsEnabled;
        customSection.title = this.configService.data.homePage.primaryAnnouncementsTitle;
        customSection.sections = this.configService.data.homePage.primaryAnnouncements; // Assuming primaryAnnouncements is an array of sections
        break;
      case "secondaryAnnouncements":
        customSection.isEnabled = this.configService.data.homePage.secondaryAnnouncementsEnabled;
        customSection.title = this.configService.data.homePage.secondaryAnnouncementsTitle;
        customSection.sections = this.configService.data.homePage.secondaryAnnouncements;
        break;
      default:
        throw new Error(`Unknown section name: ${sectionName}`);
    }
    return customSection;
  }


  getLinkedCards(): CustomSection {
    // This function returns the linked cards from the config service
    let customSection: CustomSection = {
      name: "linkedCards",
      isEnabled: this.configService.data.homePage.cardsEnabled,
      sections: this.configService.data.homePage.cards
    }
    return customSection;
  }

  getAboutTheLibrary(): CustomSection {
    // This function returns the about the library section from the config service
    let customSection: CustomSection = {
      name: "aboutLibrary",
      isEnabled: this.configService.data.homePage.aboutLibraryEnabled,
      title: this.configService.data.homePage.aboutLibraryTitle,
      content: this.configService.data.homePage.aboutLibraryText
    }
    return customSection;
  }

  getFooter(): CustomSection {
    let customSection: CustomSection = {
      name: "footer",
      isEnabled: this.configService.data.homePage.footerEnabled,
      sections: {
        contact: {
          isEnabled: this.configService.data.homePage.footerContactTitle != '' && this.configService.data.homePage.footerContactText != '',
          title: this.configService.data.homePage.footerContactTitle,
          text: this.configService.data.homePage.footerContactText
        },

        links: this.configService.data.homePage.footerLinks
      }
    }
    return customSection
  }

}

HomeController.$inject = ['$scope'];

angular.module('summonApp.controllers')
  .controller('HomeCtrl', ['$scope', 'configService', HomeController])